import { createFileRoute } from '@tanstack/react-router';
import { VideoStage } from '@/features/Lesson/VideoStage';
import { useTopicDetail } from '@/lib/hooks/useLms';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/recording')({
  component: RecordingRoute,
});

function RecordingRoute() {
  const { topicId } = Route.useParams();
  const { data: topic } = useTopicDetail(topicId);
  if (!topic) return null;
  return <VideoStage sessions={topic.sessions} />;
}
